import Vue from 'vue';
import VeeValidate, { Validator } from 'vee-validate';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import App from './App.vue';
import router from './router';
import './styles/styles.scss';

Vue.config.productionTip = false;

window.sm = {
  url: process.env.VUE_APP_API_URL,
};

// Validate Phone Number
const phoneNumber = {
  getMessage: field => `${field} is not a valid phone number`,
  validate(value) {
    return new Promise((resolve) => {
      // eslint-disable-next-line
      const phoneRegex = /^(1\s?)?((\([0-9]{3}\))|[0-9]{3})[\s\-]?[\0-9]{3}[\s\-]?[0-9]{4}$/g;
      const valid = phoneRegex.test(value);
      resolve({ valid });
    });
  },
};
Validator.extend('phoneNumber', phoneNumber);

Vue.use(ElementUI);
Vue.use(VeeValidate);

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
